import { FormikHelpers } from 'formik';
import { TailNumber, DebriefAircraft } from 'ff/debrief/models';

export const VSPEED_FIELDS = [
    'vr',
    'vx',
    'vy',
    'vref',
    'vne',
    'vs0',
    'vs1',
    'vsw',
    'vmxt',
] as const;
export type VSpeedField = (typeof VSPEED_FIELDS)[number];

export interface VspeedValues {
    vr: number;
    vx: number;
    vy: number;
    vref: number;
    vne: number;
    vs0: number;
    vs1: number;
    vsw: number;
    vmxt: number;
}

export interface VspeedFormValues extends VspeedValues {
    tailNumber: TailNumber;
    aircraftModel: DebriefAircraft;
    preferredSpeedUnit: string;
}

export type SubmitHandler = (
    values: VspeedFormValues,
    helpers: FormikHelpers<VspeedFormValues>
) => void;
